(() => {
  const duration = 280;
  const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';

  class GenLocationFaqDetails {
    constructor(details) {
      this.details = details;
      this.summary = details.querySelector('summary');
      this.answer = details.querySelector('.gen-location-faq__answer');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      if (this.summary && this.answer) {
        this.summary.addEventListener('click', (event) => this.onClick(event));
      }
    }

    onClick(event) {
      const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion || typeof this.details.animate !== 'function') return;

      event.preventDefault();

      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      this.details.classList.add('is-closing');

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      this.animation?.cancel();
      this.animation = this.details.animate(
        {height: [startHeight, endHeight]},
        {duration, easing},
      );
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    open() {
      this.details.classList.remove('is-closing');
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;

      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.answer.offsetHeight}px`;

      this.animation?.cancel();
      this.animation = this.details.animate(
        {height: [startHeight, endHeight]},
        {duration, easing},
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.classList.remove('is-closing');
      this.details.style.height = '';
    }
  }

  const initializeFaqs = () => {
    document
      .querySelectorAll('.gen-location-faq details')
      .forEach((details) => new GenLocationFaqDetails(details));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFaqs, {once: true});
  } else {
    initializeFaqs();
  }
})();
